module.exports = __webpack_public_path__ + "static/2-fee71b8c79a2311c1e41d31a660319df.png";